import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom"; // <-- Import
import "bootstrap/dist/css/bootstrap.min.css";
import "./CaseStudiesSection.css";

import case1 from "../assets/project-1.jpg";
import case2 from "../assets/project-2.jpg";
import case3 from "../assets/project-3.jpg";
import case4 from "../assets/project-4.jpg";

const caseStudies = [
  {
    id: 1,
    title: "Financial Services Digital Transformation",
    category: "Enabling a Sales Channel Through Agile Digital Transformation",
    image: case1,
  },
  {
    id: 2,
    title: "Telecommunications Infrastructure Rollout",
    category: "Building Redundant Fiber Networks to Future-Proof Growth for an ISP",
    image: case2,
  },
  {
    id: 3,
    title: "Enterprise Data Solution Architecture",
    category: "Architecting a Centralized Data Export Solution for Enhanced Business Intelligence",
    image: case3,
  },
  {
    id: 4,
    title: "Service Delivery & SLA Optimization",
    category: "Driving 100% SLA Compliance and Enhancing Service for Major B2B Accounts",
    image: case4,
  },
];

const CaseStudiesSection = () => {
  const [hovered, setHovered] = useState(null);
  const navigate = useNavigate(); // <-- Initialize navigate

  return (
    <section className="case-studies py-5 position-relative">
      <Container>
        <div className="text-center mb-5">
          <p className="section-subtitle">OUR PORTFOLIO</p>
          <h2 className="section-title">Our Latest Case Studies</h2>
        </div>

        {/* Hovered image */}
        {hovered && (
          <div className="hover-image-wrapper">
            <img
              src={caseStudies.find((s) => s.id === hovered).image}
              alt="Case Preview"
              className="hover-image show"
            />
          </div>
        )}

        {/* Full width list */}
        {caseStudies.map((study) => (
          <Row
            key={study.id}
            className="align-items-center case-row py-3"
            onMouseEnter={() => setHovered(study.id)}
            onMouseLeave={() => setHovered(null)}
          >
            <Col xs={12} sm={6} className="case-title">
              <h5>{study.title}</h5>
            </Col>
            <Col xs={12} sm={4} className="case-category text-muted">
              <span>{study.category}</span>
            </Col>
            <Col xs={12} sm={2} className="text-md-end">
              <Button
                variant="light"
                className="view-btn1"
                onClick={() => navigate(`/case-study/${study.id}`)} // <-- Redirect
              >
                → View Detail
              </Button>
            </Col>
          </Row>
        ))}
      </Container>
    </section>
  );
};

export default CaseStudiesSection;
